// import type { Action, Reducer, Effect } from 'umi';
import type { Action, Reducer } from 'umi';
import type { IPayload } from '@gp/types/global';

export interface IMilestoneOperationVisibleState {
  visible: boolean;
}

type IUpdateMilestoneOperationVisibleAction = Action<'updateMilestoneOperationVisible'> & IPayload<boolean>;

export interface IMilestoneOperationVisibleModel {
  namespace: string;
  state: IMilestoneOperationVisibleState;
  effects: {};
  reducers: {
    updateMilestoneOperationVisible: Reducer<IMilestoneOperationVisibleState, IUpdateMilestoneOperationVisibleAction>;
  };
}

export const MILESTONE_OPERATION_VISIBLE_MODEL_NAMESPACE = 'dbg-model-milestone-operation-visible';

const MilestoneOperationVisibleModel: IMilestoneOperationVisibleModel = {
  namespace: MILESTONE_OPERATION_VISIBLE_MODEL_NAMESPACE,
  state: {
    visible: false,
  },
  effects: {},
  reducers: {
    updateMilestoneOperationVisible(state, action) {
      return { ...state, visible: !!action?.payload };
    },
  },
};

export default MilestoneOperationVisibleModel;
